import { render, staticRenderFns } from "./Stores.vue?vue&type=template&id=561c1719&scoped=true&"
import script from "./Stores.vue?vue&type=script&lang=ts&"
export * from "./Stores.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561c1719",
  null
  
)

export default component.exports